<div class="db-cdn-pending">

  <div class="db-pending-header" [ngClass]="{'ds-lazy-load': initialLoading}">
    <div class="db-pending-header-wrap">
      <div class="db-pending-header-texts">
        <div class="db-pending-header-title" [innerHTML]="'text_verifyCloudflareHostnameHeader' | dbText"></div>
        <div class="db-pending-header-desc">Original server IP:<span>{{originalIp}}</span>
          <i class="db-icon db-icon-ds-edit-box" (click)="editOriginalIp()"></i>
        </div>
      </div>
      <div class="db-cdn-pending__status yellow pointer">
        <p>Pending</p>
        <div class="separator ml10"></div>
        <i class="db-icon db-icon-ds-timer small ml10"></i>
      </div>
    </div>
    <div class="db-pending-header-steps mt13">
      <ng-container *ngFor="let _step of steps[step];">
        <div class="db-pending-header-step">
          <div class="db-step-outer" [style.border-color]="_step.borderColor" [style.border-width]="_step.borderWidth">
            <span *ngIf="_step.type === 'number' && (!loading || (loading && _step.number !== step))"
                  [style.background-color]="_step.bgColor"
                  [style.color]="_step.numberColor">{{_step.number}}</span>
            <i class="db-icon db-icon-ds-cloudflare-gray" [style.color]="_step.numberColor" *ngIf="_step.type === 'icon'"></i>
            <db-loading-circular-spinner *ngIf="loading && _step.number === step" [color]="'gray'"></db-loading-circular-spinner>
          </div>
          <div class="db-line-wrap">
            <div class="db-line mb10" *ngIf="_step.type === 'number'"
                 [style.border-top-color]="_step.borderColor"
                 [style.border-top-style]="_step.line"></div>
            <span [innerHTML]="step === 1 ? _step.text : _step.text" [style.color]="_step.textColor"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="db-pending-body-wrap" [ngClass]="{'ds-lazy-load': initialLoading}">
    <div class="ds-notification-error mb20" *ngIf="!cdnIsLive && recheck">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p [innerHTML]="hasCloudflareConflict ? cloudflareConflict : cdnNotLiveMessage"></p>
      </div>
    </div>
    <div class="db-pending-body-header" [innerHTML]="title"></div>
    <div class="db-pending-body-features mt15 mb30" *ngIf="records && records.length">
      <ng-container [ngTemplateOutlet]="featuresSection"></ng-container>
    </div>
    <div class="db-pending-body-features mt20 mb30" *ngIf="records && !records.length">
      <div class="ds-notification-warning">
        <div>
          <i class="db-icon db-icon-ds-info-bg"></i>
          <p [innerHTML]="cdnPendingMessage"></p>
        </div>
      </div>
    </div>
    <div class="db-pending-body-footer">
      <button class="ds-btn-green" [ngClass]="{'ds-btn-disabled': loading}" (click)="troubleShootVerifications()">
        <span *ngIf="!loading" [innerHTML]="buttonText | lowerCaseSpecificWords"></span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </div>

  <div class="db-cancel-cloudflare-process" *ngIf="!initialLoading" [innerHTML]="'text_cancelProcess' | dbText" (click)="cancelProcess()"></div>

</div>

<ng-template #recordsSection>
  <div class="db-copy-info mt5">
    <div>
      <div class="db-copy-info__list-header">
          <p>{{ 'text_type' | dbText }}</p>
          <p>{{ 'text_hostName' | dbText }}</p>
          <p>{{ 'text_value' | dbText }}</p>
      </div>
      <div>
        <ul>
          <ng-container *ngFor="let record of records; let i = index" >
            <li class="db-copy-info__list-item {{record}}" *ngIf="record !== ''">
              <p>{{step === 1 ? record.type : 'A'}}</p>
              <p>
                <input type="text" class="form-control host-name" #inputHostName [value]="record.name">
                <a [ngxClipboard]="inputHostName" (cbOnSuccess)="copiedHostName(i)" (click)="isCopiedHostNames[i] = true"
                   (onTooltipHide)="isCopiedHostNames[i] = false"
                   class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                   dsTooltipColor="black"
                   [dsTooltip]="'<b>' + ((isCopiedHostNames[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                </a>
              </p>
              <p>
                <input type="text" class="form-control" [(ngModel)]="record.value" #inputNameServer>
                <a [ngxClipboard]="inputNameServer" (cbOnSuccess)="copiedNameServer(i)" (click)="isCopiedCodes[i] = true"
                   (onTooltipHide)="isCopiedCodes[i] = false"
                   class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                   dsTooltipColor="black"
                   [dsTooltip]="'<b>' + ((isCopiedCodes[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                </a>
              </p>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="ds-notification-warning mb5 mt20" *ngIf="step === 2">
        <div>
          <i class="db-icon db-icon-ds-info-bg"></i>
          <p>If your DNS provider only accepts fully qualified domains, use <b>{{hostname}}</b> instead of &#64;. </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #featuresSection>
  <ng-container *ngFor="let feature of features[step]; let i = index">
    <div class="db-pending-body-feature" [ngClass]="{'center': step === 1}" *ngIf="feature.step">
      <span>{{feature.step}}. </span><span class='ml7' [innerHTML]="feature.title"></span>
      <span *ngIf="feature.withLabel === true" class="db-label ml8">REQUIRED</span>
    </div>
    <ng-container [ngTemplateOutlet]="recordsSection" *ngIf="!feature.step"></ng-container>
  </ng-container>
</ng-template>

<ng-template #recordTooltip>
  <div class="db-cdn-pending__record-tooltip">
    <h4 class="mb8">Confirming that you have pointed your domain to Cloudflare</h4>
    <p class="mb10">We are checking your DNS records to<br/> confirm that you have pointed your<br/>
      domain to Cloudflare. This process can<br/> take up to 24 hours depending on your<br/>
      domain name registrar.</p>
    <p class="mb15">View the DNS records for instructions.</p>
  </div>

</ng-template>
